import { render, staticRenderFns } from "./TargetDosage.vue?vue&type=template&id=e6dbc0ea&scoped=true"
import script from "./TargetDosage.vue?vue&type=script&lang=js"
export * from "./TargetDosage.vue?vue&type=script&lang=js"
import style0 from "./TargetDosage.vue?vue&type=style&index=0&id=e6dbc0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dbc0ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
